import http from '@/utils/http';

/**
 * 佣金日志
 */
export default {
  getList: {
    p: 'post,/manage/rebate/getlist',
    r: (data) => http({ url: '/manage/rebate/getlist', method: 'post', data })
  },
  add: {
    p: 'post,/manage/rebate/add',
    r: (data) => http({ url: '/manage/rebate/add', method: 'post', data })
  },
  update: {
    p: 'post,/manage/rebate/update',
    r: (data) => http({ url: '/manage/rebate/update', method: 'post', data })
  },
  del: {
    p: 'post,/manage/rebate/delete',
    r: (data) => http({ url: '/manage/rebate/delete', method: 'post', data })
  },
  updatePass: {
    p: 'post,/manage/rebate/update_password',
    r: (data) => http({ url: '/manage/rebate/update_password', method: 'post', data })
  },
  getOne: {
    p: 'post,/manage/rebate/getOne',
    r: (data) => http({ url: '/manage/rebate/getOne', method: 'post', data })
  },
  exportFile: {
    p: 'post,/manage/rebate/export',
    r: (data) => http({ url: '/manage/rebate/export', method: 'post', data })
  }
};
